var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 960,
    height: 480,
    viewBox: "0 0 96 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#C10000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h96v48H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 3h6v18h-6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 9h18v6H11z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTo);
export default __webpack_public_path__ + "static/media/to.4173b31605e20b4eff93bd772faecea0.svg";
export { ForwardRef as ReactComponent };